import { useEffect } from 'react';
import { useFormStatus } from 'react-dom';
import { useTranslations } from 'next-intl';
import { SelectStoreResponse } from 'services/dealer-locator/types';
import { ERROR, IDLE, SUCCESS } from 'services/dealer-locator/constants';
import { useFormSubmitEvent } from 'hooks/analytics/use-form-submit-event';
import { SELECT_STORE } from 'components/dealer-locator/dealer-locator-content/constants';
import { STATUS_FAIL } from 'constants/analyticsConstants';
import { redirect } from 'next/navigation';
import { useUserConsentLoader } from '../user-consent-loader-context';

interface UserConsentDescriptionProps {
  dealerName: string;
  selectStoreAction: (payload: null) => void;
  selectStoreState: SelectStoreResponse;
  setIsSelectStoreError: (value: boolean) => void;
  storeLocationName: string;
}
export const UserConsentDescription = ({
  dealerName,
  selectStoreAction,
  selectStoreState,
  setIsSelectStoreError,
  storeLocationName
}: UserConsentDescriptionProps) => {
  const t = useTranslations();
  const { pending } = useFormStatus();
  const { fireEvent } = useFormSubmitEvent();
  const { setIsUserConsentLoading } = useUserConsentLoader();

  useEffect(() => {
    if (pending) {
      setIsUserConsentLoading(true);
      setIsSelectStoreError(false);
    } else if (selectStoreState?.message !== IDLE) {
      // Reset select store action state every time
      selectStoreAction(null);
      if (selectStoreState?.message === ERROR) {
        fireEvent({
          formName: SELECT_STORE,
          formContent: `${dealerName}, ${storeLocationName}`,
          formStatus: STATUS_FAIL
        });
        setIsUserConsentLoading(false);
        setIsSelectStoreError(true);
      } else if (selectStoreState?.message === SUCCESS) {
        fireEvent({
          formName: SELECT_STORE,
          formContent: `${dealerName}, ${storeLocationName}`
        });
        setIsSelectStoreError(false);
        redirect(selectStoreState?.url);
      }
    }
  }, [
    dealerName,
    fireEvent,
    pending,
    selectStoreAction,
    selectStoreState?.message,
    selectStoreState?.url,
    setIsUserConsentLoading,
    setIsSelectStoreError,
    storeLocationName
  ]);

  return (
    <p className="exclude-global cat-u-theme-typography-body color-extra-dark-gray mb-0 text-md">
      {t('REGISTER_MODAL_5_USER_CONSENT_SUBTEXT')}
    </p>
  );
};
